import React, { useState, useEffect, useCallback } from 'react';
import { Tabs, Tab, Paper } from '@mui/material';
import PropTypes from 'prop-types';
import TaskSummary from './TaskSummary';
import ReactJson from '@microlink/react-json-view';
import _ from 'lodash';

export default function RightPanel({ selectedTask, dag, onChangeFlow }) {
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    setTabIndex(0); // Reset to Status Tab on ref change
  }, [selectedTask]);

  const handleTabChange = useCallback(tab => () => setTabIndex(tab), []);

  let taskResult = null;
  //retryOptions = null;
  if (!selectedTask) {
    return null;
  } else {
    const { ref, taskId } = selectedTask;
    const node = dag.graph.node(ref);
    if (node) {
      if (node.taskResults.length > 1) {
        //retryOptions = node.taskResults;
      }

      if (taskId) {
        taskResult = node.taskResults.find(task => task.taskId === taskId);
      } else {
        taskResult = _.last(node.taskResults);
      }
    }
  }

  if (!taskResult) {
    return <Paper />;
  }

  return (
    <Paper>
      <Tabs value={tabIndex}>
        <Tab label='Summary' onClick={handleTabChange(0)} />
        <Tab label='Input' onClick={handleTabChange(1)} disabled={!taskResult.status} />
        <Tab label='Output' onClick={handleTabChange(2)} disabled={!taskResult.status} />
        <Tab label='JSON' onClick={handleTabChange(3)} disabled={!taskResult.status} />
        <Tab label='Definition' onClick={handleTabChange(4)} />
      </Tabs>
      <div>
        {tabIndex === 0 && <TaskSummary taskResult={taskResult} changeFlow={onChangeFlow} />}
        {tabIndex === 1 && (
          <ReactJson style={{ wordBreak: 'break-all' }} displayDataTypes={false} src={taskResult.inputData} title='Task Input' />
        )}
        {tabIndex === 2 && (
          <>
            <ReactJson style={{ wordBreak: 'break-all' }} displayDataTypes={false} src={taskResult.outputData} title='Task Output' />
          </>
        )}
        {tabIndex === 3 && (
          <ReactJson style={{ wordBreak: 'break-all' }} displayDataTypes={false} src={taskResult} title='Task Execution JSON' />
        )}
        {tabIndex === 4 && (
          <ReactJson
            style={{ wordBreak: 'break-all' }}
            displayDataTypes={false}
            src={taskResult.workflowTask}
            title='Task Definition/Runtime Config'
          />
        )}
      </div>
    </Paper>
  );
}

RightPanel.propTypes = {
  selectedTask: PropTypes.object,
  dag: PropTypes.object,
  onTaskChange: PropTypes.func,
  onChangeFlow: PropTypes.func
};
